import { useReducer } from 'react'

const toggleReducer = (state: boolean, nextValue?: any) =>
  typeof nextValue === 'boolean' ? nextValue : !state

export const useBooleanToggle = (initialValue: boolean): [boolean, (nextValue?: any) => void] => {
  // react 19 removed the single `Reducer<S, A>` type-arg overload of useReducer;
  // let the reducer's own signature drive inference.
  return useReducer(toggleReducer, initialValue)
}
